import React, { useState } from 'react';
import { CaretDown, CaretUp } from '@phosphor-icons/react';

const TaskDistributionCollapsibleSection = ({
  title,
  description,
  icon = null,
  badge = null,
  defaultExpanded = true,
  children,
  sectionClassName = 'rounded-2xl border border-line bg-surface/90 shadow-[0_20px_60px_rgba(15,23,42,0.35)]',
  contentClassName = 'border-t border-line px-4 py-4'
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <section className={`min-w-0 overflow-hidden ${sectionClassName}`}>
      <button
        type="button"
        onClick={() => setIsExpanded((current) => !current)}
        aria-expanded={isExpanded}
        className="flex w-full items-start justify-between gap-3 px-4 py-4 text-left transition hover:bg-surface/40"
      >
        <div className="flex min-w-0 items-start gap-3">
          {icon && (
            <span className="mt-0.5 shrink-0 text-content-muted">
              {icon}
            </span>
          )}

          <div className="min-w-0">
            <h2 className="text-sm font-semibold uppercase tracking-[0.16em] text-content">{title}</h2>
            {description && <p className="mt-1 text-xs text-content-muted">{description}</p>}
          </div>
        </div>

        <div className="ml-3 flex shrink-0 items-center gap-3">
          {badge}
          <span className="text-content-muted">
            {isExpanded ? <CaretUp size={18} /> : <CaretDown size={18} />}
          </span>
        </div>
      </button>

      {isExpanded && (
        <div className={contentClassName}>
          {children}
        </div>
      )}
    </section>
  );
};

export default TaskDistributionCollapsibleSection;
